
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule } from "@/store/modules/index";
import mixin from "./mixin";
import * as modals from "@/lib/modals";

const orderModule = getModule(OrderModule);

interface DefaultRequest {
  dates: boolean;
  charges: boolean;
  accessorials: boolean;
  notes: boolean;
  deliveryInstructions: boolean;
  consolidateWithLikeOrders: boolean;
  orderReferenceNumbers: boolean;
  otherReferenceNumbers: boolean;
  extraInformation: boolean;
  createNoScanBarcodeOrder: boolean;
  status: any;
  numberOfCopies: number;
}

@Component({
  name: modals.copyOrderModal
})
export default class CopyOrderModal extends Mixins(mixin) {
  request: DefaultRequest = {
    dates: false,
    charges: false,
    accessorials: false,
    notes: false,
    deliveryInstructions: false,
    consolidateWithLikeOrders: false,
    orderReferenceNumbers: false,
    otherReferenceNumbers: false,
    extraInformation: false,
    createNoScanBarcodeOrder: false,
    status: null,
    numberOfCopies: 1
  };
  loading: boolean = false;

  async copy() {
    let order = this.selectedItems[0];

    let payload = JSON.parse(JSON.stringify(this.request));
    payload.orderNumber = order.number;
    payload.numberOfCopies = parseInt(payload.numberOfCopies);
    this.loading = true;

    try {
      let response = await orderModule.copyOrder(payload);
      this.addActionResult({
        number: order.number,
        success: true,
        message: `Order ${order.number} successfully copied to ${response.data.headerNumbers.join(
          ", "
        )}.`
      });
      this.$router.push({ path: "/order/" + response.data.headerNumbers[0] });
    } catch (ex) {
      this.addActionResult({
        number: order.number,
        success: false,
        message: ex.response.data ? ex.response.data.message : "Failed to copy order",
        errors: ex.response.data && ex.response.data.errors ? ex.response.data.errors : null,
        errorMessages:
          ex.response.data && ex.response.data.errorMessages ? ex.response.data.errorMessages : null
      });
    }

    this.loading = false;
    this.hideModal();
  }
}
